import { useEffect, useRef, useState } from 'react';
import AutoComplete from 'react-google-autocomplete';
import {
  AddressAutocompleteProps,
  AddressAutocompletePropsState,
  GoogleAutoCompleteAddressComponent,
} from '../interface/interface';
import { AusPostMax40Limit, australianStates } from '../constant/constant';

export const AddressAutocomplete = (props: AddressAutocompleteProps) => {
  const addressLineRef = useRef<any>();
  const [addressComponent, setAddressComponent] = useState<
    Array<GoogleAutoCompleteAddressComponent>
  >([]);

  useEffect(() => {
    if (!addressComponent.length) return;

    const obj: Partial<AddressAutocompletePropsState> = {};
    for (const component of addressComponent) {
      switch (true) {
        case component.types.includes('subpremise'):
          obj.unit = component.long_name;
          continue;

        case component.types.includes('administrative_area_level_1'):
          obj.state = component.long_name;
          continue;

        case component.types.includes('locality'):
          obj.city = component.long_name;
          continue;

        case component.types.includes('postal_code'):
          obj.zip = component.long_name;
          continue;

        case component.types.includes('country'):
          obj.country = 'Australia';
          continue;

        case component.types.includes('street_number'):
          obj.streetNumber = component.long_name;
          continue;

        case component.types.includes('route'):
          obj.streetName = component.long_name;
          continue;

        default:
          continue;
      }
    }
    props.setter({ ...props.state, ...obj } as AddressAutocompletePropsState);
  }, [addressComponent]);

  return (
    <div className="my-2">
      <div className="flex flex-wrap -mx-3 mb-6">
        <div className="w-full px-3">
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
            htmlFor="address-line-2"
          >
            Address Line 1
          </label>
          {process.env.VITE_MAPS_AUTOCOMPLETE_KEY ? (
            <AutoComplete
              ref={addressLineRef as any}
              defaultValue={props.addressRefValue ?? ''}
              apiKey={process.env.VITE_MAPS_AUTOCOMPLETE_KEY}
              onPlaceSelected={(place) => {
                setAddressComponent(place.address_components);
              }}
              onChange={(event) => {
                if (!props.freezeAddressFields) {
                  props.address1ManualSetter(
                    (event.target as HTMLInputElement).value,
                  );
                }
              }}
              options={{
                componentRestrictions: { country: 'au' },
                debounce: 600,
                fields: ['address_components', 'geometry'],
                types: ['address'],
              }}
              className={`appearance-none block w-full text-gray-700  rounded py-3 px-4 leading-tight auto-complete-map
             ${
               props.freezeAddressFields
                 ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                 : 'shadow border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 bg-white'
             }`}
              disabled={props.freezeAddressFields}
            />
          ) : (
            <input
              className={`appearance-none block w-full text-gray-700  rounded py-3 px-4 leading-tight 
              ${
                props.freezeAddressFields
                  ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                  : 'shadow border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 bg-white'
              }`}
              id="address-line-1"
              type="text"
              value={props.addressRefValue}
              onChange={(event) => {
                if (!props.freezeAddressFields) {
                  props.address1ManualSetter(event.target.value);
                }
              }}
              disabled={props.freezeAddressFields}
            />
          )}
        </div>
      </div>
      <div className="flex flex-wrap -mx-3 mb-6">
        <div className="w-full px-3">
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2 optional-text"
            htmlFor="address-line-2"
          >
            Address Line 2
          </label>
          <input
            disabled={props.freezeAddressFields}
            className={`appearance-none block w-full  
              text-gray-700  rounded py-3 px-4 leading-tight 
               ${
                 props.freezeAddressFields
                   ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                   : 'border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 shadow bg-white '
               }`}
            id="address-line-2"
            type="text"
            value={props.state.address2}
            onChange={(event) => {
              props.setter({ ...props.state, address2: event.target.value });
            }}
            maxLength={AusPostMax40Limit}
          />
        </div>
      </div>

      {/* {location.pathname.endsWith('/cart') ? (
        <div className="flex flex-wrap -mx-3 mb-6">
          <div className="w-full px-3">
            <label
              className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
              htmlFor="special-delivery-instructions"
            >
              OPTIONAL INSTRUCTIONS (PLEASE NOTE: Parcels cannot be left
              unattended. A signature is required for all deliveries)
            </label>
            {isMobile ? (
              <textarea
                rows={2}
                disabled={props.freezeAddressFields}
                className={`appearance-none block w-full resize-none
              text-gray-700 rounded py-3 px-4 mb-3 leading-tight focus:shadow-none outline-none focus:ring-0 focus:border-primary-blue-500
               ${
                 props.freezeAddressFields
                   ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                   : 'border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 shadow bg-white '
               }`}
                id="special-delivery-instructions"
                placeholder="Special Delivery Instructions"
                value={props.state.specialDeliveryInstructions}
                onChange={(event) => {
                  props.setter({
                    ...props.state,
                    specialDeliveryInstructions: event.target.value,
                  });
                }}
                // Auspost not supporting more than 40 characters in address line 2
                maxLength={AusPostMax40Limit}
              />
            ) : (
              <input
                disabled={props.freezeAddressFields}
                className={`appearance-none block w-full  
              text-gray-700 rounded py-3 px-4 mb-3 leading-tight 
               ${
                 props.freezeAddressFields
                   ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                   : 'border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500 shadow bg-white '
               }`}
                id="special-delivery-instructions"
                type="text"
                placeholder="Special Delivery Instructions"
                value={props.state.specialDeliveryInstructions}
                onChange={(event) => {
                  props.setter({
                    ...props.state,
                    specialDeliveryInstructions: event.target.value,
                  });
                }}
                // Auspost not supporting more than 40 characters in address line 2
                maxLength={AusPostMax40Limit}
              />
            )}
          </div>
        </div>
      ) : (
        <></>
      )} */}

      <div className="flex flex-wrap -mx-3 mb-5">
        <div
          className={`w-full md:w-1/2 ${props.isForRequestToCancel ? '2xl:w-1/2 my-1' : '2xl:w-1/4'} px-3 mb-6 2xl:mb-0`}
        >
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
            htmlFor="city"
          >
            City
          </label>
          <input
            className={`appearance-none block w-full  
              text-gray-700  disabled:cursor-not-allowed 
              rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 
              ${props.freezeAddressFields ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75' : 'border border-gray-200 shadow'}`}
            id="city"
            type="text"
            onChange={(event) => {
              props.setter({ ...props.state, city: event.target.value });
            }}
            value={props.state.city}
            disabled={props.freezeAddressFields}
          />
        </div>
        <div
          className={`w-full md:w-1/2 ${props.isForRequestToCancel ? '2xl:w-1/2 my-1' : '2xl:w-1/4'} px-3 mb-6 2xl:mb-0`}
        >
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
            htmlFor="province"
          >
            State
          </label>
          <div className="relative">
            <select
              className={`block appearance-none w-full   disabled:cursor-not-allowed 
                border disabled:opacity-100 text-gray-700 py-3 px-4 pr-8 rounded 
                leading-tight  
                ${
                  props.freezeAddressFields
                    ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                    : 'border-gray-200 shadow focus:outline-none focus:bg-white focus:border-gray-500'
                }`}
              id="province"
              value={props?.state?.state}
              onChange={(event) => {
                props.setter({ ...props.state, state: event.target.value });
              }}
              disabled={props.freezeAddressFields}
            >
              {australianStates.map((aS) => (
                <option key={aS} value={aS}>
                  {aS}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div
          className={`w-full md:w-1/2 ${props.isForRequestToCancel ? '2xl:w-1/2 my-1' : '2xl:w-1/4'} px-3 mb-6 2xl:mb-0`}
        >
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
            htmlFor="zip"
          >
            Postcode
          </label>
          <input
            className={`block w-full disabled:cursor-not-allowed 
              text-gray-700  rounded py-3 px-4 leading-tight  
              ${
                props.freezeAddressFields
                  ? 'cursor-not-allowed border-0 bg-gray-200 opacity-75'
                  : 'shadow focus:outline-none focus:bg-white focus:border-gray-500 border border-gray-200'
              }`}
            id="zip"
            type="text"
            value={props.state.zip}
            onChange={(event) => {
              props.setter({ ...props.state, zip: event.target.value });
            }}
            disabled={props.freezeAddressFields}
          />
        </div>
        <div
          className={`w-full md:w-1/2 ${props.isForRequestToCancel ? '2xl:w-1/2 my-1' : '2xl:w-1/4'} px-3 mb-6 2xl:mb-0`}
        >
          <label
            className="block uppercase tracking-wide text-primary-blue-500 text-xs font-bold mb-2"
            htmlFor="grid-state"
          >
            Country
          </label>
          <div className="relative">
            <select
              className={`block appearance-none w-full bg-white  disabled:cursor-not-allowed 
                disabled:opacity-100  text-gray-700 py-3 px-4 pr-8 rounded 
                leading-tight  
                ${props.freezeAddressFields ? 'border-0' : 'shadow border border-gray-200 focus:outline-none focus:bg-white focus:border-gray-500'}`}
              id="grid-state"
              disabled={true}
            >
              <option value={props.state.country}>{props.state.country}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
